<template>
  <StatsWidgetData
    :configuration="config.widgetConfiguration"
    :name="config.widgetName"
  />
</template>

<script lang="ts">
import {
  defineComponent, PropType, ref, watch,
} from 'vue';
import { WidgetDataData } from '@/components/stats-builder/metadata/WidgetDataMetadata';
import StatsWidgetData from '@/components/stats/StatsWidgetData.vue';
import { getComponentStatsWidgetMetadata } from '@/components/stats-builder/metadata';

export default defineComponent({
  name: 'StatsWidgetDataRender',
  components: {
    StatsWidgetData,
  },

  props: {
    widgetData: {
      type: Object as PropType<WidgetDataData>,
      required: false,
      default() {
        return {};
      },
    },
  },

  setup(props: { widgetData: WidgetDataData}) {
    const config = ref(props.widgetData);

    watch(() => props.widgetData, async (newValue, oldValue) => {
      // Ne pas déclencher si c'est le même objet (même référence)
      if (newValue === oldValue) {
        return;
      }

      // Vérifier si les propriétés importantes ont vraiment changé
      if (oldValue && newValue
        && JSON.stringify(newValue.widgetConfiguration) === JSON.stringify(oldValue.widgetConfiguration)
        && newValue.widgetName === oldValue.widgetName) {
        return;
      }

      const meta = getComponentStatsWidgetMetadata('StatsWidgetData');
      if (!meta) {
        return;
      }
      let updateRender = false;
      if (meta.Validate) {
        const valid = await meta.Validate(props.widgetData);
        updateRender = valid.success;
      }

      if (updateRender) {
        /* Si les données sont valides, on met à jour la config */
        config.value = props.widgetData;
      }
    }, { flush: 'post' });

    return {
      config,
    };
  },
});
</script>

<style lang="scss">
#pageRowsList .titleChart {
  text-align: center;
  margin-bottom: 1rem;
}
</style>
